"use client";

import { useEffect } from "react";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { setCredentials, clearCredentials } from "@/store/slices/authSlice";

// Same mock user map as lib/mockAuth.js — in Phase 21 this becomes a real "/me" API call
const MOCK_USERS_BY_ROLE = {
  owner: {
    id: "1",
    name: "AeronPay Owner",
    email: "owner@aeronpay.in",
    role: "owner",
  },
  super_admin: {
    id: "2",
    name: "Org Admin",
    email: "admin@aeronpay.in",
    role: "super_admin",
    orgId: "org1",
  },
  hr: {
    id: "3",
    name: "HR User",
    email: "hr@aeronpay.in",
    role: "hr",
    orgId: "org1",
  },
  manager: {
    id: "4",
    name: "Team Manager",
    email: "manager@aeronpay.in",
    role: "manager",
    orgId: "org1",
  },
  employee: {
    id: "5",
    name: "John Employee",
    email: "employee@aeronpay.in",
    role: "employee",
    orgId: "org1",
  },
};

export default function AuthProvider({ children }) {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = Cookies.get("aeronpay_token");
    const role = Cookies.get("aeronpay_role");

    if (token && role && MOCK_USERS_BY_ROLE[role]) {
      dispatch(setCredentials(MOCK_USERS_BY_ROLE[role]));
    } else {
      dispatch(clearCredentials());
    }
  }, [dispatch]);

  return children;
}
